import React, { useEffect } from "react";
import BookSession from "../components1/BookSession";

const Booking = () => {
  // Scroll to top when the page loads
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <BookSession />
    </div>
  );
};

export default Booking;
